import type { FC, ReactNode } from "react";

import { FlippersProvider as BaseFlippersProvider, FlippersContext } from "@shared/context";
import { useInitialProps } from "@unauthenticated/catalog/context/InitialPropsProvider";

interface Props {
  children: ReactNode;
}

const FlippersProvider: FC<Props> = ({ children }) => {
  const { flippers } = useInitialProps();

  return <BaseFlippersProvider flippers={flippers ?? []}>{children}</BaseFlippersProvider>;
};

export { FlippersContext, FlippersProvider };
